/*
  Pestañas de información.

  Se usa el patrón de tabs accesible: los botones llevan role="tab", los paneles
  role="tabpanel", y se navega también con flechas del teclado, que es lo que
  espera un lector de pantalla al encontrar una lista de pestañas.
*/
class MateryPestanas extends HTMLElement {
  connectedCallback() {
    this.botones = [...this.querySelectorAll('[role="tab"]')];
    this.paneles = [...this.querySelectorAll('[role="tabpanel"]')];
    if (!this.botones.length) return;

    this.botones.forEach((boton, i) => {
      boton.addEventListener('click', () => this.activar(i));
      boton.addEventListener('keydown', (e) => this.teclado(e, i));
    });

    this.activar(0);
  }

  activar(indice) {
    this.botones.forEach((boton, i) => {
      const activo = i === indice;
      boton.setAttribute('aria-selected', activo ? 'true' : 'false');
      // Solo la pestaña activa entra en el recorrido del tabulador.
      boton.tabIndex = activo ? 0 : -1;
      this.paneles[i].hidden = !activo;
    });
  }

  teclado(evento, indice) {
    const salto = { ArrowRight: 1, ArrowLeft: -1 }[evento.key];
    if (!salto) return;
    evento.preventDefault();
    const siguiente = (indice + salto + this.botones.length) % this.botones.length;
    this.botones[siguiente].focus();
    this.activar(siguiente);
  }
}

customElements.define('matery-pestanas', MateryPestanas);
